<div>
  <mat-dialog-content>
    <p>
      Paste simple date or ISO-8601 UTC date. The <i>'Z'</i> at the end of a
      ISO-8601 UTC date is optional.
    </p>
    <ul class="list-disc pl-6 mt-2">
      <li><strong>Simple date:</strong> [yyyy-mm-dd]</li>
      <li><strong>ISO-8601 UTC date:</strong> [yyyy-mm-ddThh:mm]</li>
      <li><strong>ISO-8601 UTC date:</strong> [yyyy-mm-ddThh:mm:ss]</li>
      <li><strong>ISO-8601 UTC date:</strong> [yyyy-mm-ddThh:mm:ss.sss]</li>
    </ul>
    <div class="datetime-input-dialog relative">
      <mat-form-field class="datetime-input-dialog__form-field">
        <mat-label>Date</mat-label>
        <input
          required
          matInput
          [(ngModel)]="dateValue"
          (ngModelChange)="isValidISODate()"
        />
      </mat-form-field>
      @if (!isValid && dateValue) {
        <mat-error class="datetime-input-dialog__invalid">
          <small>The value entered is an invalid ISO-8601 date</small>
        </mat-error>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="w-full flex items-center justify-between p-2">
      <button mat-button mat-dialog-close>Cancel</button>
      <button
        color="primary"
        matButton="filled"
        [mat-dialog-close]="dateValue"
        [disabled]="!dateValue || !isValid"
      >
        Paste
      </button>
    </div>
  </mat-dialog-actions>
</div>
